import { render } from "./TourDetails.vue?vue&type=template&id=df3da794"
import script from "./TourDetails.vue?vue&type=script&lang=js"
export * from "./TourDetails.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__